'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import Accreditations from "@/img/accreditations.webp"
import Image from "next/image"
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { getStrapiImageHeight, getStrapiImageUrl, getStrapiImageWidth } from '@/app/lib/util';
import {TrustedProps} from "@/app/types/flexible-content.types";
import {StrapiImageProps} from "@/app/types/strapi.types";
import {ReactNode} from "react";

interface TestimonialProps {
    children: ReactNode
    name: string
    location: string
    image: string
    imageWidth: number
    imageHeight: number
    colour: "purple" | "orange" | "green"
    imageRounded?: boolean
}

function Testimonial(props: TestimonialProps) {

    let backgroundColour = '';
    let foregroundColour = '';

    switch (props.colour) {
        case "purple":
            backgroundColour = "bg-[#CDA3EE]";
            foregroundColour = "bg-[#B576E7]";
            break;
        case "orange":
            backgroundColour = "bg-[#FFE4A7]";
            foregroundColour = "bg-[#FFB61F]";
            break;
        case "green":
            backgroundColour = "bg-[#D0FBDB]";
            foregroundColour = "bg-[#76D68F]";
            break;
        default:
            break;
    }

    return (
        <>
            <div className={`rounded-[25px] ${backgroundColour} overflow-hidden relative text-white my-12`}>
                <div className={`w-[1205px] h-[1205px] rounded-full ${foregroundColour} absolute top-1/2 mt-[-602px] left-[-150px] z-0`}></div>
                <div className="p-8 pb-20 lg:px-20 lg:py-16 flex flex-col lg:flex-row relative items-center justify-between z-10 relative">
                    <div className="text-left max-w-[815px] lg:pr-24">
                        <div className="text-2xl mb-8">
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div className="text-lg lg:text-2xl mb-8">
                            {props.children}
                        </div>
                        <hr className="max-w-[60px] mb-8" />
                        <div>{props.name}</div>
                        <div>{props.location}</div>
                    </div>
                    <div>
                        <Image quality={85} width={props.imageWidth} height={props.imageHeight} alt={props.name} src={props.image} className={`absolute lg:relative bottom-[25px] lg:bottom-0 right-[25px] lg:right-0 max-w-[100px] ${props.imageRounded ? "aspect-square rounded-full" : ""} mt-12 lg:mt-0 lg:max-w-[413px] `} />
                    </div>
                </div>
            </div>
        </>
    )
}



export default function Trusted(props: {data: TrustedProps}) {
    return (
        <>
            <section className="py-10 xl:py-16 overflow-hidden">
				<div className="container text-left lg:text-center lg:px-16">
                    {props.data.Title ? (<h2 className="text-4xl xl:text-5xl font-bold ">{props.data.Title}</h2>) : null}
					{props.data.Slide ? (
                         <Splide
                            className="visible-track-overflow"
                            options={{
                                focus: "center",
                                gap: 30
                            }}
                         >
                            {props.data.Slide.map((slide, index: number) => (
                                <SplideSlide key={index}>
                                    <Testimonial name={slide.PostedBy} location={slide.Location} image={getStrapiImageUrl(slide.ProfileImage)} imageWidth={getStrapiImageWidth(slide.ProfileImage)} imageHeight={getStrapiImageHeight(slide.ProfileImage)} colour={slide.ColourScheme} imageRounded={slide.ImageRounded}>
                                        &quot;{slide.Quote}&quot;
                                    </Testimonial>
                                </SplideSlide>
                            ))}
                         </Splide>
                    ) : null}

					<div className="flex justify-center">
						<Image quality={85} src={Accreditations} alt="Accreditations" className="w-full max-w-full lg:max-w-[679px] lg:w-auto" />
					</div>
				</div>
			</section>
        </>
    )
}
